import { defineMessages } from 'react-intl'

export default defineMessages({
  orderId: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDetails.orderId',
    defaultMessage: 'Order ID',
  },
  deadline: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDetails.deadline',
    defaultMessage: 'Deadline',
  },
  po: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDetails.po',
    defaultMessage: 'P.O.',
  },
  status: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDetails.status',
    defaultMessage: 'Status',
  },
  usageRights: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDetails.usageRights',
    defaultMessage: 'Usage Rights',
  },
  importantLinks: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDetails.importantLinks',
    defaultMessage: 'Important Links',
  },
  auditionOverviewLink: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDetails.auditionOverviewLink',
    defaultMessage: 'Audition Overview',
  },
  auditionLandingPageLink: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDetails.auditionLandingPageLink',
    defaultMessage: 'Audition Landing Page',
  },
  feedbackRequestLink: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDetails.feedbackRequestLink',
    defaultMessage: 'How did we do?',
  },
  usageNotSet: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDetails.usageNotSet',
    defaultMessage: 'Not set',
  },
  usageChipTitle: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDetails.usageChipTitle',
    defaultMessage: 'Click to view full usage history',
  }
})
